import React from 'react'
import CogenDashboard from './CogenDashboard';
import BreadCrumb from './BreadCrumb';
function CogenDashboardPage() {
    return ( 
        <div className = "container-fluid">
        <BreadCrumb />
        <CogenDashboard />
        </div>
     );
}

export default CogenDashboardPage;